import Actions from './entitlement-actions';
import Api from './entitlement-api';
import reducer from './entitlement-reducer';
import sagas from './entitlement-sagas';
import Selectors from './entitlement-selectors';

export default {
  Actions,
  Api,
  namespace: 'entitlement',
  reducer,
  sagas:     [sagas],
  Selectors,
};
